import React, { useEffect, useState } from "react";
import TransitionPreviewCanvas from "../components/TransitionPreviewCanvas";
import { TRANSITIONS } from "../utils/transitions";

export default function TransitionPanel({
  index,
  images,
  clipTransitions,
  onChangeTransition,
  transitionDuration,
  onChangeDuration,
  setActiveSection
}) {

  console.log("TransitionPanel render for index:", index,images,clipTransitions);

  const [loadedImages, setLoadedImages] = useState([]);

useEffect(() => {
  if (!images || !images.length) return;

  const arr = [];
  let loadedCount = 0;

  images.forEach((imgObj) => {
    const img = new Image();
    img.src = imgObj.url; // <-- use blob URL
    img.onload = () => {
      loadedCount++;
      if (loadedCount === images.length) {
        setLoadedImages(arr);
      }
    };
    arr.push(img);
  });
}, [images]);


  // CURRENT transition data
  const currentType = clipTransitions[index] || "fade";

  // Grab the two images involved in this transition
  const imgA = loadedImages[index];
  const imgB = loadedImages[index + 1] || loadedImages[index];


  // For re-rendering preview when type/duration changes
  const [localType, setLocalType] = useState(currentType);
  const [localDuration, setLocalDuration] = useState(transitionDuration);

  useEffect(() => setLocalType(currentType), [currentType]);
  useEffect(() => setLocalDuration(transitionDuration), [transitionDuration]);

  if (index === null || index < 0) {
    return <div className="p-4 text-gray-400">No transition selected.</div>;
  }
  // Ensure both images exist before proceeding with the main content
  if (!imgA || !imgB) {
      return <div className="p-4 text-gray-400">Loading images...</div>;
  }
  

return (
  <div
    className="
      p-4 h-full overflow-y-auto
      flex flex-col gap-6
      text-gray-900 dark:text-gray-100
    "
  >
    {/* Title */}
    <h2 className="text-xl font-semibold">Transition</h2>

    {/* Subtitle */}
    <p className="text-sm text-gray-600 dark:text-gray-400">
      Clip {index + 1} → {index + 2}
    </p>

    {/* ───────── Big Preview ───────── */}
    <div className="w-full flex justify-center">
      <div
        className="
          p-2 rounded-lg
          bg-gray-100 dark:bg-gray-900
          border border-gray-200 dark:border-gray-800
        "
      >
        <TransitionPreviewCanvas
          key={localType + localDuration}
          transition={localType}
          imgA={imgA}
          imgB={imgB}
        />
      </div>
    </div>

    {/* ───────── Transition Type ───────── */}
    <div className="flex flex-col gap-1">
      <label className="text-sm text-gray-600 dark:text-gray-400">
        Transition Type
      </label>

      <select
        className="
          p-2 rounded-md w-full
          bg-white dark:bg-gray-800
          border border-gray-300 dark:border-gray-700
          text-gray-900 dark:text-gray-100
          focus:outline-none focus:ring-2 focus:ring-blue-500
        "
        value={localType}
        onChange={(e) => {
          setLocalType(e.target.value);
          onChangeTransition(index, e.target.value);
          setActiveSection("images");
        }}
      >
        {Object.keys(TRANSITIONS).map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>
    </div>

    {/* ───────── Duration Slider ───────── */}
    <div className="flex flex-col gap-1">
      <label className="text-sm text-gray-600 dark:text-gray-400">
        Transition Duration ({localDuration}s)
      </label>

      <input
        type="range"
        min={0.2}
        max={3}
        step={0.1}
        value={localDuration}
        onChange={(e) => {
          const v = parseFloat(e.target.value);
          setLocalDuration(v);
          onChangeDuration(v);
        }}
        className="w-full accent-blue-500"
      />
    </div>

    {/* ───────── All Transitions Grid ───────── */}
    <div>
      <h3 className="text-md font-semibold mb-3">
        All Transitions
      </h3>

      <div className="grid grid-cols-2 gap-4">
        {Object.keys(TRANSITIONS).map((t) => (
          <button
            key={t}
            onClick={() => {
              setLocalType(t);
              onChangeTransition(index, t);
              setActiveSection("image");
            }}
            className={`
              p-2 rounded-lg text-left
              bg-white dark:bg-gray-900
              border transition-colors
              ${
                localType === t
                  ? "border-blue-500"
                  : "border-gray-300 dark:border-gray-700"
              }
              hover:bg-gray-100 dark:hover:bg-gray-800
            `}
          >
            <div className="flex justify-center">
              <TransitionPreviewCanvas
                transition={t}
                imgA={imgA}
                imgB={imgB}
              />
            </div>

            <div className="mt-1 text-center text-xs text-gray-600 dark:text-gray-300">
              {t}
            </div>
          </button>
        ))}
      </div>
    </div>
  </div>
);

}
